import React from 'react';
import ProductCategory from 'components/ContentfulFields/ProductCategory';
import { THEMES } from 'components/ThemeProvider';

import styles from './styles.scss';

const Categories = ({ content }) => (
  <section className={styles.productCategories}>
    <ul>
      {content.map((document) => (
        <li key={document.sys.id}>
          <ProductCategory
            document={document}
            stylesTheme={THEMES.WATER_REGIONAL}
            isShowcase="true"
          />
        </li>
      ))}
    </ul>
  </section>
);

export default Categories;
